import { useNavigate } from "react-router-dom";
import { Button, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { MobileNumber, UserName } from "../../../Constants/Constants";
import { Route } from "../../../Routers/RouteList";
import { dynamicImage, Image } from "../../../Utils";
import BgImage from "./BgImage";
import TermsCondition from "./TermsCondition";

const LoginContainer = () => {
  const navigate = useNavigate();
  return (
    <div className="login-page">
      <Container fluid className="p-0">
        <Row>
          <BgImage />
          <Col xs="12" lg="6" className="px-0">
            <div className="left-page">
              <div className="login-content">
                <div className="login-content-header mb-3 text-center">
                  <Image className="image-fluid m-auto" src={dynamicImage("logo/logo.png")} alt="images" />
                </div>
                <h3 className="text-center">
                  {"Welcome to "}
                  <span className="font-primary">{"Chatzy"}</span>
                </h3>
                <p className="text-center">{"Access your chat from a computer anytime, anyplace."}</p>
                <Form className="form1">
                  <FormGroup>
                    <Label className="col-form-label">{UserName}</Label>
                    <Input type="text" placeholder="Enter your name"/>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{MobileNumber}</Label>
                    <Row>
                      <Col xs="4" sm="4">
                        <Input type="select">
                          <option value={1}>(+1)</option>
                          <option value={91}>(+91)</option>
                          <option value={81}>(+81)</option>
                          <option value={44}>(+44)</option>
                        </Input>
                      </Col>
                      <Col xs="8" sm="8" className="px-0">
                        <Input className="mb-1" type="tel" placeholder="Enter your mobile number"/>
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <div className="buttons">
                      <Button color="primary" className="button-effect w-100 justify-content-center" onClick={() => navigate(Route.Messenger)}>
                        {"Send Verification Code"}
                      </Button>
                    </div>
                  </FormGroup>
                </Form>
                <TermsCondition />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoginContainer;
